import { AxiosResponse } from 'axios';

import { RecognizeResponse } from '../types/api';
import { CreatedRecord } from '../types/record';

export const pathWithId = (path: string, id: string) => {
	return path.replace('{id}', id);
};

export const getNextDateOffset = <T extends CreatedRecord = CreatedRecord>(lastPage: AxiosResponse<RecognizeResponse<T[]>>): string | undefined => {
	const result = lastPage?.data?.result;
	return result ? result[result.length - 1]?.created_at : undefined;
};

export const getOffsetFromPageFactory = (recordsPerPage: number) => (pageParam: number) => ({
	limit: recordsPerPage,
	skip: (pageParam - 1) * recordsPerPage,
});
